<template>
  <div class="projects">
    <ag-table :data-source-api="getAllCoupons" :grid-options="gridOptions" :permissions="permissions" :rtl="false"
      :is-entities-response="false" @emitAddNewRecord="onCreateCoupon()" />
    <tm-popup :submit="onCouponPopupSubmit" :title="couponPopupTitle" ref="couponPopup">
      <div class="vx-row justify-start">
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="اسم الكوبون" placeholder="اسم الكوبون" type="text" validation-rules="required"
            v-model="coupon.name" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getAppsOptions" label="name" validation-rules="required" name="المشروع"
            :reduce="app => app.id" v-model="coupon.appId" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="الكود" placeholder="الكود" validation-rules="required" v-model="coupon.code" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-input class="w-full" name="عدد النقاط" placeholder="عدد النقاط" type="number" validation-rules="required"
            v-model="coupon.points" />
        </div>
        <div class="vx-col sm:w-1/2 w-full mb-2 mt-2">
          <tm-select class="w-full" :options="getCouponStatusOptions" label="name" validation-rules="required"
            name="حالة الكوبون" :reduce="name => name.value" v-model="coupon.status" />
        </div>
      </div>
    </tm-popup>
  </div>
</template>

<script>
import FilePondComponent from "@/app/shared/shared-components/FilePondComponent";
import TmInput from "@/app/shared/shared-components/TmInput";
import TmPopup from "@/app/shared/shared-components/TmPopup";
import TmSelect from "@/app/shared/shared-components/TmSelect";
import TmTextArea from "@/app/shared/shared-components/TmTextArea";
import AgButton from "../../../shared/shared-components/ag-grid/AgButton";
import AgTableBtnCell from "../../../shared/shared-components/ag-grid/AgTableBtnCell";
import AgTable from '../../../shared/shared-components/ag-grid/AgTableServerSide.vue';
import { RepositoryFactory } from '../../loyalty-repositories/loyaltyRepositoryFactory';

const couponsRepo = RepositoryFactory.get('couponsRepository');
const appsRepo = RepositoryFactory.get('appsRepository');
export default {
  name: "Coupons",
  components: {
    AgTable,
    TmInput,
    AgTableBtnCell,
    TmPopup,
    AgButton,
    TmTextArea,
    FilePondComponent,
    TmSelect
  },
  data() {
    return {
      gridApi: null,
      gridOptions: null,
      couponPopupTitle: '',
      status: {
        active: 'فعّال',
        inactive: 'معطّل',
      },
      apps: [],
      coupon: {
        name: null,
        appId: null,
        code: null,
        points: null,
        status: 'active',
      },
      permissions: {
          add: 'coupons_manage',
          edit: 'coupons_manage',
          delete: 'coupons_manage',
      }
    };
  },
  methods: {
    createColDefs() {
      let self = this;
      return [
        {
          headerName: 'اسم الكوبون',
          field: 'name',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'المشروع',
          field: 'appId',
          // filter: 'agTextColumnFilter',
          valueGetter:
            function getObject(params) {
              return params.data.app ? params.data.app.name : '-';
            },
          width: 200,
          sortable: false
        },
        {
          headerName: 'الكود',
          field: 'code',
          filter: 'agTextColumnFilter',
          width: 200,
          sortable: false
        },
        {
          headerName: 'عدد النقاط',
          field: 'points',
          filter: 'agNumberColumnFilter',
          width: 200,
          sortable: true
        },
        {
          headerName: 'حالة الكوبون',
          field: 'status',
          width: 200,
          sortable: true,
          valueGetter:
            function getObject(params) {
              return self.status[params.data.status] || '-';
            },
          filter: 'agSetColumnFilter',
          filterParams: {
            values: Object.keys(self.status),
            valueFormatter: value => self.status[value]
          }
        },
        {
          headerName: 'تم اسناد الكوبون',
          field: 'isAssigned',
          width: 200,
          sortable: false,
          valueGetter:
            function getObject(params) {
              return params.data.isAssigned ? 'نعم' : 'لا';
            },
        },
        {
          headerName: 'الإجراءات',
          field: 'id',
          cellRendererFramework: AgTableBtnCell,
          sortable: false,
          cellRendererParams: {
            deleteRecord: function (id) {
              self.onDeleteCoupon(id);
            },
            editRecord: function (coupon) {
              self.onUpdateCoupon(coupon);
            },
            hideRecordActions: function (data) {
              return data.isAssigned ? ['edit', 'delete'] : [];
            },
            actions: ['edit', 'delete'],
            permissions: self.permissions,
          },
        }
      ];
    },
    async onDeleteCoupon(couponId) {
      await couponsRepo.removeCoupon(couponId);
      await this.gridApi.refreshServerSideStore({ purge: true });
    },
    onUpdateCoupon(coupon) {
      this.couponPopupTitle = 'تعديل معلومات الكوبون';
      this.resetCouponForm();
      Object.assign(this.coupon, coupon);
      this.$refs.couponPopup.open();
    },
    onCreateCoupon() {
      this.couponPopupTitle = 'إضافة كوبون جديد';
      this.resetCouponForm();
      this.$refs.couponPopup.open();
    },
    resetCouponForm() {
      Object.assign(this.coupon, {
        name: null,
        appId: null,
        code: null,
        points: null,
        status: 'active',
      });
    },
    async onCouponPopupSubmit() {
      try {
        let res = null;
        const couponPayload = {
          ...this.coupon,
          points: parseInt(this.coupon.points)
        };
        if (this.couponPopupTitle == 'إضافة كوبون جديد') {
          res = await couponsRepo.createCoupon(couponPayload);
        } else {
          res = await couponsRepo.updateCoupon(couponPayload);
        }

        if (res.status === 201 || res.status === 200) {
          this.$refs.couponPopup.close();
          await this.gridApi.refreshServerSideStore({ purge: true });
        }
      } catch (err) {
        this.$refs.couponPopup.endLoading();
      }
    },
    async getAllCoupons(query) {
      return await couponsRepo.fetchCoupons(query);
    },
    async getAllApps() {
      const res = await appsRepo.fetchApps();
      this.apps = res.data;
    },
  },
  computed: {
    getCouponStatusOptions() {
      return Object.keys(this.status).map(key => ({
        name: this.status[key],
        value: key
      }));
    },
    getAppsOptions() {
      return this.apps.filter(app => app.status === 'active').map(app => ({
        name: app.name,
        id: app.id
      }));
    }
  },
  created() {
    this.gridOptions = {};
    this.gridOptions.columnDefs = this.createColDefs();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.getAllApps();
  }
};
</script>
